<template>
  <div id="deviceTree">
    <header class="tabs-box clearfix">
        <div :class="{'active':state==1}" @click="headClick(1)" id="headClick0"><span>分组</span></div>
        <div :class="{'active':state==2}" @click="headClick(2)" id="headClick1"><span>支线</span></div>
    </header>
    <div class="title clearfix">
      <div class="f-l" id="root" @click="reset"><img :src="homeUrl">默认组</div>
      <div class="f-r" v-show="!$store.state.isLook">
        <img ref="add" title="新建" v-show="treeObj.level<10||treeObj.level==0" :src="add" @mouseover="imgHover('add')"
          @mouseout="disHover('add')" @click="popup('addShow')">
        <img :src="add3" title="新建" v-show="treeObj.level>9">
        <img ref="edit" title="编辑" v-show="treeObj.level!=0" :src="edit" @mouseover="imgHover('edit')"
          @mouseout="disHover('edit')" @click="popup('editShow')">
        <img :src="edit3" title="编辑" v-show="treeObj.level==0">
        <img ref="del" title="删除" v-show="treeObj.level!=0" style="width: 18px;" :src="del" @mouseover="imgHover('del')"
          @mouseout="disHover('del')" @click="popup('delShow')">
        <img style="width: 18px;" title="删除" :src="del3" v-show="treeObj.level==0">
      </div>
      <div class="f-r not-allowed" v-show="$store.state.isLook">
        <img :src="add3" title="新建">
        <img :src="edit3" title="编辑">
        <img style="width: 18px;" title="删除" :src="del3">
      </div>
    </div>
    <!-- 组织树  -->
    <div class="tree">
      <el-tree ref="tree" :indent='0' :expand-on-click-node="false" :data="treeData" :check-on-click-node="false"
        node-key="id" :props="defaultProps" @node-click="nodeClick" :default-expand-all="true">
        <span class="custom-tree-node" slot-scope="{ node, data }" :ref="setRef(data)" :class="{'m-l-2':data.type==1}">
          <!-- <i><img :src="meter" class="tree-icon"></i> -->
          <span :class="generateClassName(data.id)">{{ node.label }}</span>
        </span>
      </el-tree>
    </div>
    <div class="popup">
      <!-- 添加 -->
      <div class="popup-content" v-show="addShow">
        <div class="popup-title m-b-22">
          新建组织<i class="el-icon-circle-close close" @click="close('addShow')"></i>
        </div>
        <el-form :model='ruleForm' :rules="rules" ref="addForm" class="clearfix">
          <div class="popup-lab">
            <el-form-item prop="name" label="组名称：" autocomplete="off" class="no-title">
              <i><img :src="notes" title="组名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
              <el-input v-model="ruleForm.name" maxlength="32" placeholder="请输入组名称"></el-input>
            </el-form-item>
            <el-form-item prop="parentId" label="上级组：" autocomplete="off" class="no-title">
              <!-- <el-select v-model="ruleForm.parentId" placeholder="请选择" class="type-select">
                <el-option :key="0" label="默认组" :value="0"></el-option>
                <el-option v-for="item in treeData" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select> -->
              <el-cascader class="w-466"
                  @change="key+=1"
                  :key="key"
                  v-model="ruleForm.parentId"
                  :options="cascaderTree"
                  :props="optionProps"
                  :show-all-levels="false"
                  clearable></el-cascader>
            </el-form-item>
            <el-form-item label="绑定设备：" autocomplete="off" class="no-title" v-show="state==2">
              <el-select v-model="ruleForm.deviceId" placeholder="请选择" class="type-select" clearable>
                <el-option v-for="item in devList" :key="item.id" :label="item.name" :value="item.id" :disabled="bindList.includes(item.id)&&item.id!=ruleForm.oldDevId"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div class="btn-box">
          <el-button type="primary" @click='clickAdd'>确定</el-button>
          <el-button @click="close('addShow')">取消</el-button>
        </div>
      </div>
      <div class="popup-content" v-show="editShow">
        <div class="popup-title m-b-22">
          修改组织<i class="el-icon-circle-close close" @click="close('editShow')"></i>
        </div>
        <el-form :model='ruleForm' :rules="rules" ref="editForm" class="clearfix">
          <div class="popup-lab">
            <el-form-item prop="name" label="组名称：" autocomplete="off" class="no-title">
              <i><img :src="notes" title="组名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
              <el-input v-model="ruleForm.name" maxlength="32" placeholder="请输入组名称"></el-input>
            </el-form-item>
            <el-form-item prop="parentId" label="上级组：" autocomplete="off" class="no-title">
              <el-cascader
                  class="w-466"
                  @change="key+=1"
                  :key="key"
                  v-model="ruleForm.parentId"
                  :options="cascaderTree"
                  :props="optionProps"
                  :show-all-levels="false"
                  clearable></el-cascader>
            </el-form-item>
            <el-form-item label="绑定设备：" autocomplete="off" class="no-title" v-show="state==2">
              <el-select v-model="ruleForm.deviceId" placeholder="请选择" class="type-select" clearable>
                <el-option v-for="item in devList" :key="item.id" :label="item.name" :value="item.id" :disabled="bindList.includes(item.id)&&item.id!=ruleForm.oldDevId"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div class="btn-box">
          <el-button type="primary" @click='clickEdit'>确定</el-button>
          <el-button @click="close('editShow')">取消</el-button>
        </div>
      </div>
      <!-- 删除组织 -->
      <div class="popup-content" v-show='delShow'>
          <div class="popup-title m-b-22">
              删除组织<i class="el-icon-circle-close close" @click="close('delShow')" id="closeDelOr"></i>
          </div>
          <div class="popup-lab">
              <p>组织删除后不可恢复，是否继续？</p>
          </div>
        <div class="btn-box">
          <el-button type="primary" @click='yes'>确定</el-button>
          <el-button @click="close('delShow')">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        homeUrl: null,
        add: require('@/assets/image/organize/add.png'),
        del: require('@/assets/image/organize/delete.png'),
        add2: require('@/assets/image/organize/add2.png'),
        del2: require('@/assets/image/organize/delete2.png'),
        edit: require('@/assets/image/organize/edit.png'),
        edit2: require('@/assets/image/organize/edit2.png'),
        add3: require('@/assets/image/organize/add3.png'),
        del3: require('@/assets/image/organize/delete3.png'),
        edit3: require('@/assets/image/organize/edit3.png'),
        add4: require('@/assets/image/organize/add4.png'),
        del4: require('@/assets/image/organize/delete4.png'),
        edit4: require('@/assets/image/organize/edit4.png'),
        area: require('@/assets/image/company/jf.png'),
        // meter: require('@/assets/image/company/deviceIcon.png'),
        notes: require('@/assets/image/organize/notes.png'),
        addShow: false,
        editShow: false,
        delShow: false,
        key:1,
        optionProps: {
            value: 'id',
            label: 'name',
            children: 'children',
            expandTrigger: 'hover',
            checkStrictly: true,
            emitPath:false
        },
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        // typeArr: [{
        //     name: '电',
        //     id: 1
        //   },
        //   {
        //     name: '水',
        //     id: 2
        //   },
        //   {
        //     name: '气',
        //     id: 3
        //   },
        //   {
        //     name: '热',
        //     id: 4
        //   }
        // ],
        treeObj: {id:'0',name:'默认组',level:0},
        treeData:[],
        cascaderTree:[],
        ruleForm: {
          name: null,
          parentId: null,
        },
        devList:[],
        bindList:[],
        rules: {
          name: [{
            message: '请输入组名称',
            required: true,
            trigger: 'blur'
          }],
          parentId: [{
            message: '请输入上级组',
            required: true,
            trigger: 'blur'
          }],
          type: [{
            message: '请选择类型',
            required: true,
            trigger: 'blur'
          }],
        }
      }
    },
    computed:{
      state(){
        return this.$store.state.deviceTreeType
      },
    },
    props: {
      treeData1: {
        type: Array,
        default: () => {
          return []
        },
      },
      companyId:{
          type:Number,
          required:true,
      },
      type: {
        type: Number,
        default: 1   //1 不带设备  2 带设备
      },
      treeType: {
        type: Number,
        default: 1   //1电，２水，３气，４热
      },
    },
    created() {
      this.homeUrl = require("@/assets/image/organize/xinweiwo" + this.cssType + ".png")
      this.$store.state.mask=false
    },
    mounted() {
      this.getDevList()
      this.getTreeData()
    },
    methods: {
      getTreeData(){
        let data={
          companyId:this.companyId,
          type:this.state
        }
        this.get('/DeviceGroup/getTree',data).then(res=>{
          if(res.success){
            let arr= this.clone(res.result)
            this.setLevel(arr,1,true)
            this.treeData = arr
            // 上级组数据
            this.cascaderTree= [{id:'0',name:'默认组',level:0,children:arr}]
            this.setLevel(res.result,1,false)
            this.$store.state.deviceTreeData = [{id:'0',name:'默认组',level:0,children:res.result}]
            console.log(this.$store.state.deviceTreeData)
          }else{
            this.$message({
                type:'warning',
                message:this.state==1?`获取企业设备分组失败：${res.message}`:`获取企业设备分支失败：${res.message}`
            })
          }
        })
      },
      // 获取全部设备
      getDevList(){
        this.get('/DeviceGroup/getDeviceList',{companyId:this.companyId,id:0}).then(res=>{
          if(res.success){
            this.devList = res.result
            this.resetBind()
          }
        })
      },
      // 更新被绑定的设备
      resetBind(){
        this.get('/DeviceGroup/getBindDeviceList',{companyId:this.companyId}).then(res=>{
          if(res.success){
            // this.devList =
            this.bindList = res.result.map(item=>{return item.id})
            console.log(this.bindList)
          }
        })
      },
      setLevel(data,lv,disabled){
        for(let item of data){
          item.level = lv
          if(lv==10&&disabled){
            item.disabled = true
          }else if(lv==10){
            item.children=null
          }
          if(item.children){
            this.setLevel(item.children,lv+1,disabled)
          }
        }
      },
      yes(){
        this.get('/DeviceGroup/remove',{companyId:this.companyId,id:this.treeObj.id}).then(res=>{
          if(res.success){
            this.getTreeData()
            this.reset()
            this.close('delShow')
          }else{
            this.$message({
              message:`删除失败：${res.message}`,
              type:'warning'
            })
          }
        })
      },
      reset(){
        this.treeObj = {id:'0',name:'默认组',level:0}
        this.$emit('changenode', this.treeObj)
      },
      // 点击节点
      nodeClick(obj, node) {
        console.log('emit')
        this.treeObj = node.data
        this.treeObj.level = node.level
        this.$emit('changenode', this.treeObj)
      },
      headClick(i){
        this.$store.state.deviceTreeType = i
        this.getTreeData()
      },
      // 动态渲染树节点时设置id
      generateClassName(index) {
        return `item-${index}`
      },
      setRef(obj) {
        if (obj) {
          obj.key = 'node_' + obj.id + '_' + obj.type
          return 'node_' + obj.id + '_' + obj.type
        }
      },
      close(key) {
        this[key] = false;
        this.key++
        this.$store.state.mask = false
        if(this.state==2){
          this.resetBind()
        }
      },
      popup(key) {
        if(key =='editShow'){
          this.ruleForm = this.clone(this.treeObj)
          this.ruleForm.oldDevId = this.ruleForm.deviceId
          if(this.ruleForm.parentId==0){
            this.ruleForm.parentId='0'
          }
        }else{
          this.ruleForm = this.$options.data().ruleForm
          this.ruleForm.parentId=this.treeObj.id
        }
        this[key] = true;
        this.$store.state.mask = true
      },
      // 图标hover
      imgHover(id) {
        if (this.cssType == 0) {
          if (id == "add") {
            this.$refs.add.src = this.add2
          } else if (id == "edit") {
            this.$refs.edit.src = this.edit2
          } else {
            this.$refs.del.src = this.del2
          }
        } else if (this.cssType == 1) {
          if (id == "add") {
            this.$refs.add.src = this.add4
          } else if (id == "edit") {
            this.$refs.edit.src = this.edit4
          } else {
            this.$refs.del.src = this.del4
          }
        }
      },
      disHover(id) {
        if (id == "add") {
          this.$refs.add.src = this.add
        } else if (id == "edit") {
          this.$refs.edit.src = this.edit
        } else {
          this.$refs.del.src = this.del
        }
      },
      // 创建
      clickAdd(){
        this.$refs.addForm.validate((valid) => {
            if (valid) {
              let data ={
                companyId:this.companyId,
                parentId:this.ruleForm.parentId,
                name:this.ruleForm.name,
                type:this.state
              }
              if(data.parentId==='0'){
                data.parentId = 0
              }
              if(this.state==2){
                data.deviceId = this.ruleForm.deviceId
              }
              this.postNoJson('/DeviceGroup/create',data).then(res=>{
                  if(res.success){
                    this.getTreeData()
                  }else{
                      this.$message({
                          message:`创建失败：${res.message}`,
                          type:'warning'
                      })
                  }
                  this.close('addShow')
              })
            }
        })
      },
      // 编辑
      clickEdit(){
        this.$refs.editForm.validate((valid) => {
            if (valid) {
              let data ={
                id:this.ruleForm.id,
                companyId:this.companyId,
                parentId:this.ruleForm.parentId,
                name:this.ruleForm.name,
                type:this.state
              }
              if(data.parentId==='0'){
                data.parentId = 0
              }
              if(this.state==2){
                data.deviceId = this.ruleForm.deviceId
              }
              this.postNoJson('/DeviceGroup/update',data).then(res=>{
                  if(res.success){
                    this.getTreeData()
                    this.close('editShow')
                  }else{
                      this.$message({
                          message:`编辑失败：${res.message}`,
                          type:'warning'
                      })
                  }
              })
            }
        })
      },
    },
    watch: {
      treeData(){
        if (!this.treeObj.id || this.treeData.length != 0) {
          this.treeObj = {id:'0',name:'默认组',level:0}
          this.$emit('changenode', this.treeObj)
        }
      },
    }
  }
</script>

<style scoped>
  .w-466{
    width: 100%;
  }
  .tabs-box{
      height: 34px;
      overflow: hidden;
      background-color: #fff;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      border: 1px solid #d2d2d2;
      margin-bottom: 16px;
  }
  .tabs-box div{
      float: left;
      padding: 9px 0;
      width: 50%;
      text-align: center;
  }
  .tabs-box span{
      float: left;
      display: inline-block;
      width: 100%;
      font-size: 14px;
      line-height: 18px;
      border-left: 1px solid #e2e2e2;
      cursor:pointer;
  }
  .tabs-box>div:first-child span{
      border: none;
  }
  .active{
      background: #5087e4;
      color: #fff;
  }
  .active>span{
      border: 0;
  }
  #deviceTree {
    margin: 20px 16px 0;
    width: 297px;
    padding: 20px;
    padding-right: 10px;
    box-sizing: border-box;
    background-color: #fff;
    text-align: left;
    position: absolute;
    bottom: 0;
    top: 40px;
    left: 0;
    /* min-height: 817px; */
  }

  #deviceTree .title {
    font-size: 16px;
  }

  .title>div:first-child {
    cursor: pointer
  }

  .type-select {
    width: 100% !important;
    line-height: 34px !important;
  }

  #deviceTree .title img {
    position: relative;
    top: 2px;
    margin-right: 10px;
    cursor: pointer;
    width: 20px;
  }

  #deviceTree .title img:first-child {
    margin-right: 10px;
  }

  .popup>div {
    position: fixed;
    top: 10%;
    left: 50%;
    padding: 0 28px;
    box-sizing: border-box;
    margin-left: 255px;
    width: 578px;
    background-color: #fff;
    z-index: 9999;
    padding-bottom: 48px;
  }

  .popup-title {
    font-size: 16px;
    line-height: 64px;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 22px;
    text-align: left;
  }

  i .notes {
    position: relative;
    top: 5px;
  }

  i.close {
    font-size: 20px;
    float: right;
    margin-top: 24px;
  }

  .popup-del .popup-title {
    margin-bottom: 12px;
  }

  .popup-lab {
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 18px;
  }

  .popup-btn-box {
    text-align: center;
    margin-top: 30px;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 38px;
  }

  .popup-btn-box .el-button {
    padding: 0 34px !important;
    line-height: 34px !important;
    margin: 0 20px;
  }

  .btn-box {
    text-align: center;
    margin-top: 30px;
  }

  .btn-box .el-button {
    padding: 0 34px !important;
    line-height: 34px !important;
    margin: 0 16px;
  }

  .not-allowed,.not-allowed img {
    cursor: not-allowed;
  }
  .m-b-22 {
    margin-bottom: 22px !important;
  }
</style>
<style type="text/css">
  #deviceTree .popup .el-form-item {
    width: 100% !important;
    margin-bottom: 11px !important;
  }

  #deviceTree .popup .el-form .el-input__inner {
    width: 100% !important;
    height: 34px !important;
    line-height: 34px !important;
  }

  #deviceTree .popup .el-input__icon {
    line-height: 34px !important;
  }

  #deviceTree .tree .is-current>.el-tree-node__content {
    background-color: #dfdfdf !important;
  }

  /* 修改ele-ui 默认样式 */
  #deviceTree .tree .el-tree-node__content .custom-tree-node {
    font-size: 14px !important;
    margin-left: 10px;
    position: relative;
    justify-content: stretch !important;
  }

  #deviceTree .tree .el-tree-node__children .custom-tree-node {
    font-size: 14px !important;
    padding-right: 10px;
  }

  #deviceTree .el-tree-node>.el-tree-node__children {
    overflow: unset !important;
  }

  #deviceTree .tree .el-tree>.el-tree-node:after {
    border-top: none;
  }

  #deviceTree .tree .el-tree-node {
    position: relative;
    padding-left: 16px;
  }

  #deviceTree .tree .el-tree-node__content {
    background: #fff;
  }

  /* //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉 */
  #deviceTree .tree .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  #deviceTree .tree .el-tree-node__children {
    padding-left: 16px;
  }

  #deviceTree .tree .el-tree-node :last-child:before {
    height: 18px;
  }

  #deviceTree .tree .el-tree>.el-tree-node:before {
    border-left: none;
  }

  #deviceTree .tree .el-tree>.el-tree-node:after {
    border-top: none;
  }

  #deviceTree .tree .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #deviceTree .tree .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #deviceTree .tree .el-tree-node:before {
    border-left: 1px dashed #dedede;
    bottom: 0px;
    height: 100%;
    top: -7px;
    width: 1px;
  }

  #deviceTree .tree .el-tree-node:after {
    border-top: 1px dashed #dedede;
    height: 20px;
    top: 12px;
    width: 24px;
  }

  #deviceTree .el-input__inner {
    color: #252525;
  }

  #deviceTree .dashed .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #deviceTree .dashed .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #deviceTree .dashed .el-tree-node:before {
    border-left: 1px dashed #dedede;
    bottom: 0px;
    height: 100%;
    top: -7px;
    width: 1px;
  }

  #deviceTree .dashed .el-tree-node:after {
    border-top: 1px dashed #dedede;
    height: 20px;
    top: 12px;
    width: 24px;
  }

  #deviceTree .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  #deviceTree .tree {
    overflow: auto;
    position: absolute;
    top: 100px;
    bottom: 0;
    left: 30px;
    right: 0;
  }
  #deviceTree .m-l-2{
    margin-left: 2px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/PublicAssembly/deviceTree.vue